import script from "./DisjointChannelTool.vue?vue&type=script&lang=js"
export * from "./DisjointChannelTool.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__